import { DEFAULT_DONUT_CHART_COLORS } from "./constant";

export const applyColors = (data) => {
  return data.map((item, index) => ({
    ...item,
    color: DEFAULT_DONUT_CHART_COLORS[index % DEFAULT_DONUT_CHART_COLORS.length],
  }));
};